import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../button/button.module';
import { IconicModule } from '../../../iconic/iconic.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { MeasurementComponent } from './measurement.component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    SelectBoxModule,
    ButtonModule,
    TooltipModule,
    IconicModule,
    BlockModalDragModule,
  ],
  declarations: [MeasurementComponent],
  exports: [MeasurementComponent],
})
export class MeasurementModule {}
